import { render } from "./NewebPayReturn.vue?vue&type=template&id=ba7d2448&scoped=true"
import script from "./NewebPayReturn.vue?vue&type=script&lang=js"
export * from "./NewebPayReturn.vue?vue&type=script&lang=js"

import "./NewebPayReturn.vue?vue&type=style&index=0&id=ba7d2448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7d2448"]])

export default __exports__